import { render, staticRenderFns } from "./LogoRsvpifyFull.vue?vue&type=template&id=ec55d748"
import script from "./LogoRsvpifyFull.vue?vue&type=script&lang=js"
export * from "./LogoRsvpifyFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports